import { render } from "./AttendanceInterface.vue?vue&type=template&id=1d55f560&scoped=true"
import script from "./AttendanceInterface.vue?vue&type=script&lang=js"
export * from "./AttendanceInterface.vue?vue&type=script&lang=js"

import "./AttendanceInterface.vue?vue&type=style&index=0&id=1d55f560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d55f560"]])

export default __exports__